import React, { useEffect, useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./RescheduleModal.module.css";
import TextArea from "../../Component/TextArea";
import { RxCross2 } from "react-icons/rx";
import { Input } from "../../Component/Input/Input";
import { Button } from "../../Component/Button/Button";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import Switch from "../../Component/Switch/Switch";

const RescheduleModal = ({
  show,
  setShow,
  selectedItem,
  handleEdit,
  isLoadingEdit,
}) => {
  const [value, onChange] = useState(
    new Date(moment(selectedItem?.scheduledDate).format()) || new Date()
  );
  const [time, setTime] = useState(
    moment(selectedItem?.scheduledDate).format("h") || 12
  );
  const [minute, setMinute] = useState(
    moment(selectedItem?.scheduledDate).format("mm") || 35
  );
  const [checked, setChecked] = useState(
    moment(selectedItem?.scheduledDate).format("A") == "AM" ? true : false
  );

  return (
    <>
      <style>
        {`
        
        .custom_calendar_b .react-calendar{
            width: 100%;
            border:0;
            border-bottom:1px solid gray;
        }
        .react-calendar__tile--now {
            background: unset !important;
        }
        .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus {
            background: unset !important;
        }
        button.react-calendar__tile abbr {
          width: 25px;
          height: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: auto;
      }
        .react-calendar__tile--active {
            display: flex;
            justify-content: center;
        }
        .react-calendar__tile--active abbr {
            width: 25px;
        height: 25px;
        background: #06aa61;
        display: flex;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
    }
        
        
        `}
      </style>

      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"689px"}
        //   header={"Login"}
        borderRadius={"20px"}
        //   showCloseIcon
      >
        <div className="custom_calendar_b">
          <Calendar onChange={onChange} value={value} />
        </div>
        <div className={classes.time_div}>
          <div className={classes.first_div}>
            <div>
              <div className={classes.time_div_child}>
                <p>Hour</p>
                <input
                  type="text"
                  pattern="\d*"
                  maxlength="2"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                />
              </div>
            </div>
            <div>
              <div className={classes.time_div_child}>
                <p>Min</p>
                <input
                  type="text"
                  pattern="\d*"
                  maxlength="2"
                  value={minute}
                  onChange={(e) => setMinute(e.target.value)}
                />
              </div>
            </div>
            <div className={`checkBox-div ${classes.checkboxDiv}`}>
              <label>AM</label>
              <Switch setter={() => setChecked(!checked)} value={checked} />
              <label>PM</label>

              {/* <div class="toggleWrapper">
                <input
                  type="checkbox"
                  class="dn"
                  id="dn"
                  onChange={(e) => {
                    setChecked(e.target.checked);
                  }}
                />
                <label for="dn" class="toggle">
                  <span class="toggle__handler">
                    <span class="crater crater--1"></span>
                    <span class="crater crater--2"></span>
                    <span class="crater crater--3"></span>
                  </span>
                  <span class="star star--1"></span>
                  <span class="star star--2"></span>
                  <span class="star star--3"></span>
                  <span class="star star--4"></span>
                  <span class="star star--5"></span>
                  <span class="star star--6"></span>
                </label>
              </div> */}
            </div>
          </div>
          <div className={classes.btn_div}>
            <Button
            disabled={isLoadingEdit}
              label={isLoadingEdit ? "Please Wait..." : "Update"}
              onClick={() => {
                const date = moment(value).format("YYYY-MM-DD");

                const mergedDate = moment(
                  `${date} ${time}:${minute} ${!checked ? "AM" : "PM"}`
                ).format("YYYY-MM-DD h:mm A");

                handleEdit({
                  _id: selectedItem?._id,
                  scheduledDate: new Date(mergedDate),
                });
              }}
            />
          </div>
        </div>

        <div className={`mt-3 ${classes.show_time_div}`}>
          <h6>
            SELECTED : {moment(value).format("DD/MM/YYYY")}, {time}:{minute}{" "}
            {!checked ? "AM" : "PM"}
          </h6>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default RescheduleModal;
